import React, { useState, useCallback, useEffect } from "react";
import CardProject from "../components/CardProject";
import VideoSlider from "../components/VideoSlider";
import CardWorkflow from "../components/CardWorkflow";
import excelFile from "../../src/data.xlsx";
import ReadExcel from "../components/utils/ReadExcel";

export default function Foto() {
  useEffect(() => {
    document.title = "Fotografieprojekte - Erik Schott";
  }, []);

  const slides = [
    { title: "SocialMedia", type: "image", imageUrl: "/images/projekteFoto/Social_media.webp" },
    { title: "Event", type: "image", imageUrl: "/images/projekteFoto/Events.webp" },
    { title: "Landschaftsbilder", type: "image", imageUrl: "/images/projekteFoto/Landschaftsbilder.webp" },
    { title: "Dokumentation", type: "image", imageUrl: "/images/projekteFoto/Dokumentation.webp" },
    { title: "MakingOf", type: "image", imageUrl: "/images/projekteFoto/Making_of.webp" }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [excelData, setExcelData] = useState({ ProjekteFoto: [], WorkflowFoto: [] });

  const handleDataLoad = useCallback((data) => {
    setExcelData(data);
  }, []);

  const goToPrevious = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? slides.length - 1 : prevIndex - 1));
  }, [slides.length]);

  const goToNext = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex === slides.length - 1 ? 0 : prevIndex + 1));
  }, [slides.length]);

  return (
    <>
      <ReadExcel filePath={excelFile} onDataLoad={handleDataLoad} />
      <div className="page-wrapper">
        <div className="max-wrapper">
          <div className="content-head">
            <h1 className="h1">Fotografie</h1>
            <VideoSlider slides={slides} currentIndex={currentIndex} goToPrevious={goToPrevious} goToNext={goToNext} />
          </div>
        </div>
        <div className="content-wrapper">
          <div className="content-head">
            <h2 className="h1">Projekte</h2>
            <h3 className="h4">Ausgesuchte Arbeiten</h3>
          </div>
          <div className="thumbnail-wrapper">
          {excelData.ProjekteFoto
            ?.filter((card) =>
              card.key?.trim().toLowerCase() === slides[currentIndex].title.trim().toLowerCase()
            )
            .map((card) => (
              <CardProject
                key={`${card.titel}-${card.image}`}
                titel={card.titel}
                rolle={card.rolle}
                image={card.image}
                link={"#"}
                type={card.type}
              />
          ))}
          </div>
        </div>
        <div className="content-wrapper">
          <div className="content-head">
            <h2 className="h1">Workflow</h2>
            <h3 className="h4">So arbeiten wir zusammen</h3>
          </div>
          <div className="card-wrapper">
            {excelData.WorkflowFoto?.map((card) => (
              <CardWorkflow key={card.titel} titel={card.titel} image={card.image} beschreibung={card.beschreibung} nummer={card.nummer} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}